var chuffedStats = [
    { label: 'raised', value: '$350M' },
    { label: 'campaigns', value: '60K' },
    { label: 'countries', value: '23' },
    { label: 'donors', value: '3.5M' },
];
export default chuffedStats;
